import * as React from "react";
import PropTypes from "prop-types";

import DialogFormWithMutation from "dialogs/DialogFormWithMutation";
import { FormTextField } from "ui/Form";

import {
  CREATE_ACCOUNT_NOTE,
  READ_ACCOUNT_NOTES_QUERY,
} from "graphqlQueries/accounts";

import { noteValidator } from "validators/noteValidator";

const CreateAccountNote = ({ accountId, ...otherProps }) => {
  const initialValues = React.useMemo(
    () => ({
      text: "",
      id_ipmp: accountId,
    }),
    [accountId],
  );

  return (
    <DialogFormWithMutation
      mutationQueries={CREATE_ACCOUNT_NOTE}
      refetchQueries={[READ_ACCOUNT_NOTES_QUERY]}
      initialValues={initialValues}
      validationSchema={noteValidator}
      title="New note"
      submitButtonName="Save"
      className="dialog-default-width"
      fieldsWithPlaceForError={["text"]}
      {...otherProps}
    >
      <FormTextField name="text" label="Text" multiline />
    </DialogFormWithMutation>
  );
};

CreateAccountNote.propTypes = {
  accountId: PropTypes.number.isRequired,
};

export default CreateAccountNote;
